import React from 'react';
import { Expense } from '../../../../interfaces/delivery-company/expenses';
import CustomDialog, {
  CustomDialogProps,
} from '../../../common/custom-dialog/custom-dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import ExpenseForm from './expense-form';
import { isMobile, isTablet } from 'react-device-detect';

function ExpenseFormDialog({
  defaultExpense,
  onClose,
  onSuccess,
}: {
  defaultExpense?: Expense;
  onSuccess: (e: Expense) => void;
} & CustomDialogProps) {
  return (
    <CustomDialog open={true} fullWidth fullScreen={(isMobile && !isTablet)} onClose={onClose}>
      <DialogContent>
        <ExpenseForm
          onSuccess={(e) => {
            onSuccess(e);
            onClose && onClose();
          }}
          defaultExpense={defaultExpense}
        />
      </DialogContent>
    </CustomDialog>
  );
}

export default ExpenseFormDialog;
